<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="12" class="mt-1">
            <h4>{{ $t('global.error_reports_list_title') }}</h4>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <b-table class="table-sm text-center" responsive bordered :fields="tableFields" :items="tableItems">
                <template v-slot:cell(options)="{ item }">
                  <router-link :to="{ name: 'ErrorReportView', params:{ id: item.id }}">
                    <a><i class="fa fa-eye fa-lg"/></a>
                  </router-link>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator-->
            <b-col cols="12" v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import Services from '@/services';

export default {
  name: 'ErrorReports',
  components: {
    Pagination
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      tableFields: [
        { key: 'id', label: this.$t('global.id'), sortable: true },
        { key: 'email', label: this.$t('global.email'), sortable: true },
        { key: 'description', label: this.$t('error_reports.description'), sortable: true },
        { key: 'created_at', label: this.$t('global.created_at'), sortable: true },
        { key: 'options', label: this.$t('global.options') },
      ],
      tableItems: [],
      listPaginator: null,
    };
  },
  watch: {
    page() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.spinners.contentIsLoading = true;

      Services.errorReports.list({ page: this.page }).then(({ data }) => {
        this.tableItems = data.data.map((item) => {
          return {
            id: item.id,
            email: item.user ? item.user.email : '',
            description: item.description.length > 50 ? `${item.description.slice(0, 50)}...` : item.description,
            created_at: item.created_at,
          };
        });
        this.listPaginator = data.meta;
      }).catch(() => {
        this.alertError();
      }).finally(() => {
        this.spinners.contentIsLoading = false;
      });
    },
    onPageChange(page) {
      this.$router.push({ name: 'ErrorReports', params: { page } });
    },
  },
};
</script>
<style lang="">

</style>
